import { useEffect, useState } from 'react'

export function useChatInputFocus(isAtBottom: boolean) {
  const [isChatInputFocused, setIsChatInputFocused] = useState(false)

  useEffect(() => {
    const chatInput = document.getElementById('chat_input')

    const wrapper = document.getElementById(
      'app-wrapper',
    ) as HTMLDivElement | null

    if (!chatInput || !wrapper) return

    const handleFocus = () => {
      setIsChatInputFocused(true)

      if (isAtBottom && window.visualViewport) {
        setTimeout(() => {
          wrapper.scrollTo({
            behavior: 'smooth',
            top: wrapper.scrollHeight,
          })
        }, 700)
      }
    }

    const handleBlur = () => {
      setIsChatInputFocused(false)
    }

    chatInput.addEventListener('focus', handleFocus)

    chatInput.addEventListener('blur', handleBlur)

    setIsChatInputFocused(document.activeElement?.id === 'chat_input')

    return () => {
      chatInput.removeEventListener('focus', handleFocus)

      chatInput.removeEventListener('blur', handleBlur)
    }
  }, [isAtBottom])

  return { isChatInputFocused }
}
